import axios from 'axios';

export const getErrorStatus = (error: unknown): number | null => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    if (typeof status === 'number') {
      return status;
    }
  }

  return null;
};
